// extracted by mini-css-extract-plugin
module.exports = {"ProdukJasaNav":"ProdukJasaNav_ProdukJasaNav__3j01Y","active":"ProdukJasaNav_active__LkJ5p"};